export const foundationName = "The Guided Pathway Foundation";

export const foundationWebsite = "https://theguidedpathwayfoundation.com";

export const foundationMission =
  "The Guided Pathway Foundation creates practical pathways for emotional intelligence, community care, prevention, and shared growth.";

export const guidingStarsConnection =
  "Guiding Stars is the Foundation’s internal service, learning, and recognition program. It helps every contribution connect to the mission we share.";
